"use client";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import AnchorButton from "../AnchorButton";
import {ButtonVariant} from "../Button";
import {faArrowRightFromBracket} from "@fortawesome/sharp-regular-svg-icons/faArrowRightFromBracket";
import useSignOutHref from "./useSignOutHref";
import withSuspense from "../withSuspense";

const HamburgerSignOutButton = () => {
	const href = useSignOutHref();
	return (
		<AnchorButton
			id="mobile-sign-out-button"
			variant={ButtonVariant.SECONDARY}
			className="normal-case"
			href={href}
			shouldUseNextRouter={false}
		>
			Sign Out
			<FontAwesomeIcon icon={faArrowRightFromBracket} className="pl-2" />
		</AnchorButton>
	);
};

export default withSuspense(HamburgerSignOutButton);
